<template>
  <div class="py-16">
    <div class="w-full max-w-md mx-auto">
      <FormCreate
        v-if="canCreateAccount"
        ref="formCreate"
        :submitting="creating"
        @submit="handleAccountCreation"
      />

      <div>
        <BaseHeading :level="2"> Missing Account </BaseHeading>
      </div>
    </div>
  </div>
</template>

<script>
import { accountMethods } from '@/store/helper';
import { hasPermission } from '@/store/authHelpers';
import FormCreate from '@/components/Accounts/FormCreate.vue';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'AccountCreate',
  mixins: [veeValidateErrorsMixin],
  components: {
    FormCreate,
  },
  data: () => ({
    creating: false,
  }),
  computed: {
    canCreateAccount() {
      return hasPermission('create accounts');
    },
  },
  methods: {
    ...accountMethods,
    handleAccountCreation(accountData) {
      if (!this.canCreateAccount || this.creating) {
        return;
      }

      this.creating = true;
      this.storeAccount(accountData)
        .then(({ accountId }) => {
          this.creating = false;
          this.redirectToAccount(accountId);
        })
        .catch(({ errors = {} }) => {
          this.observer = this.$refs.formCreate.$refs.observer;
          this.addServerErrors(errors);
          this.creating = false;
        });
    },
    redirectToAccount(accountId) {
      this.$router.replace({ name: 'accounts.show', params: { accountId } });
    },
  },
};
</script>
